import {RootDesc} from "@ui/descriptions/RootDesc";
import {H3} from "@ui/titles/H3";
import {useTranslation} from "react-i18next";

import styles from "./styles.module.scss";

export const WarningData = ({type = "empty", title, desc}) => {
  const {t} = useTranslation();

  if (type === "error") {
    return (
      <div className={styles.warningData}>
        <div className={"text-[var(--red)]"}>
          <H3>{title || t("server_error.table_error_title")}</H3>
        </div>

        <RootDesc>
          <span className={"text-[var(--grey)]"}>
            {desc || t("server_error.table_error_subtitle")}
          </span>
        </RootDesc>
      </div>
    );
  } else if (type === "empty") {
    return (
      <div className={styles.warningData}>
        <H3>{title || t("server_error.table_empty_title")}</H3>

        <RootDesc>
          <span className={"text-[var(--grey)]"}>
            {desc || t("server_error.table_empty_subtitle")}
          </span>
        </RootDesc>
      </div>
    );
  }
};
